import type ChatProvider from './schema/ChatProvider';
import type ChatStore from './schema/ChatStore';
import { createStore } from 'owa-satcheljs';

const initialChatStore: ChatStore = {
    chatProvider: 0,
};

const defaultExport: () => ChatStore = createStore<ChatStore>('chatStore', initialChatStore);
export default defaultExport;
